import {Duration} from 'moment'

export function formatToHoursAndMinutes(durationInMinutes: number): string {
    const hours: number = Math.floor(durationInMinutes / 60)
    const minutes: number = durationInMinutes % 60
    return format(hours, minutes)
}

export function formatToHoursAndMinutesFromDuration(time: Duration): string {
    const hours: number = Math.floor(time.asHours())
    const minutes: number = time.minutes()
    return format(hours, minutes)
}

function format(hours: number, minutes: number): string {
    if (hours === 0) {
        return minutes + '分'
    } else if (minutes === 0) {
        return hours + '時間'
    } else {
        return hours + '時間' + minutes + '分'
    }
}
